<section class="check-boxes">
  <mat-checkbox color="primary">Pening</mat-checkbox>
  <mat-checkbox color="primary">Overdue</mat-checkbox>
  <mat-checkbox color="primary">Late</mat-checkbox>
  <mat-checkbox color="primary">Signed</mat-checkbox>
  <mat-checkbox color="primary">Reported</mat-checkbox>
</section>
